import React, { useEffect, useState } from "react";
import moment from "moment";
import { ColumnConfigProvider } from "../../components/controls/tables/ColumnConfigProvider";
import Table from "../../components/controls/tables/Table";

const MeetingRegistery = (props) => {
  const { allMeetings, getMettingsRegistery, loading } = props;
  const [data, setData] = useState([]);
  const [dates, setDates] = useState({});

  useEffect(() => {
    var startDate = moment().startOf("month").format("YYYY-MM-DD");
    var endDate = moment().endOf("month").format("YYYY-MM-DD");
    setDates({ startDate, endDate });
    getMettingsRegistery(`StartDate=${startDate}&EndDate=${endDate}`);
  }, []);

  const handleSearch = (filteredData) => {
    setData(filteredData);
  };

  const handleFilter = (payload) => {
    var startDate = payload.startDate
      ? moment(payload.startDate).format("YYYY-MM-DD")
      : dates.startDate;
    var endDate = payload.endDate
      ? moment(payload.endDate).format("YYYY-MM-DD")
      : dates.endDate;

    let a = `StartDate=${startDate}&EndDate=${endDate}`;
    if (payload?.projectId && payload?.projectId != "all") {
      a += `&projectId=${payload?.projectId}`;
    }
    getMettingsRegistery(a);
  };

  useEffect(() => {
    if (Array.isArray(allMeetings) && allMeetings.length > 0){
      setData(allMeetings);
    }
    else{
      setData([]);
    }
  }, [allMeetings]);

  return (
    <ColumnConfigProvider tableName="MeetingRegistry">
      <div className="listingScreen position-relative">
        <Table
          type="MeetingRegistry"
          rows={data || []}
          searchHandler={() => {}}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          setPageNum={() => {}}
          loading={loading}
          pagination={() => {}}
          setSelectedRow={() => {}}
          filterRegistry={handleFilter}
          body={null}
        />
      </div>
    </ColumnConfigProvider>
  );
};

export default MeetingRegistery;
